import styled from 'styled-components'

export const Container = styled.div`
  border-radius: var(--radius-brand);
  padding: var(--space-500) var(--space-600);
  background: var(--bg-secondary);
  line-height: var(--font-line-height-400);
`

export const Subtitle = styled.h4`
  color: var(--text-secondary);
  font-size: var(--font-size-200);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-200);
`
